import { Component, inject, ViewChild } from '@angular/core';
import { ModalProviderComponent } from 'src/app/components/inventory-modals/modal-provider.component';
import { Supplier } from 'src/app/models/supplier.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { STORAGE_KEYS } from 'src/app/services/storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-index-provider',
  template: `
    <div class="d-flex flex-column mb-4 mt-4">
      <div class="flex-column">
        <h1>Inventario</h1>
      </div>
      <div class="flex-column">
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex">
      <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
      <ul #subnav app-nav-inventory [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div #pages class="flex-fill">
      <div class="d-flex mt-0">
        <div class="flex-fill">
          <div class="d-flex">
            <div>
              <h2>Proveedores</h2>
            </div>
            <div class="flex-fill"></div>
            <div class="flex-fill text-end">
              <button class="btn btn-zazz-default rounded-4 shadow-sm px-4 ms-2" (click)="openModalProviders()">
                <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
                Agregar
              </button>
            </div>
          </div>
          <div class="list-group rounded-5 shadow mt-4" >
            <div class="list-group-item px-4 py-3 border-0">
              <div class="d-flex flex-fill mt-2">
                <!-- div class="btn-group text-center w-100" role="group" aria-label="Filtro recibos">
                  <input type="text" class="form-control form-control-sm" placeholder="Buscar proveedor..." [(ngModel)]="query.search" (ngModelChange)="loadProviders()">
                </div -->
              </div>
            </div>
            <div class="list-group-item w-100" >
              <table class="table table-sm" style="overflow-x: scroll;">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz text-light py-2"># Nombre <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-start bg-zazz text-light py-2">Correo electrónico</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Activo</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Sitio web</th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-supplier
                    [supplier]="supplier"
                    [profile]="profile" 
                    [permissions]="permissions"
                    *ngFor="let supplier of suppliers | paginate: { itemsPerPage: query.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal-provider 
      [supplier]="selectedSupplier"
      (updateDismiss)="loadProviders()"
    ></app-modal-provider>
  `,
  styleUrls: []
})
export class IndexProviderComponent {
  suppliers: Supplier[] = [];
  selectedSupplier: Supplier | null = null;
  profile: any = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PROFILE) ?? '{}');
  permissions: any = {};
  meta: any = {};
  currentView: string = 'providers';
  @ViewChild(ModalProviderComponent, { static: true }) modalProviderComponent !: ModalProviderComponent;

  query: any = {
    per_page: 10,
    page: 0
  };

  p: number = 1;

  constructor(
    private invService: InventoryService,
    public icons: IconsService
  ) { 
    this.loadProviders();
  }

  loadProviders() {
    this.invService.getSuppliers(this.query).subscribe({
      next: (res: any) => {
        console.log(res);
        this.suppliers = res.data;
        this.meta = res.meta || {};
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  openModalProviders(): void {
    console.log()
    const modalTemplate: any | undefined = this.modalProviderComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalProvider']);
    }
  }

}
